define('lib/getMatchedRouteParams',['require'],function(require) {

  return function getMatchedRouteParams(data) {
    var result = {};

    data.route._paramsIds.forEach(function(value, idx) {
      result[value] = data.params[idx];
    });

    return result;
  };

});

